import React, { useState } from "react";
import { Tabs } from "antd";
import TrainingClassForm from "./TrainingClassForm";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import ClassModules from "../modules/index";
import ClassParticipants from "../participants/index";
import TrainingModuleResults from "../results/index";

const TrainingClassTab = ({ recordId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(lastSegment);

  const items = [
    { 
      key: "view", 
      label: "Details", 
      children: (
        <div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
          <SectionHeader title="Class Details">
            <PopupButton id="edit_classModule" title="Edit Class" label="Edit">
              <TrainingClassForm recordId={recordId} mode="edit"  />
            </PopupButton>
          </SectionHeader>
          <TrainingClassForm recordId={recordId} mode="view" />
        </div>
      )
    },

    { 
      key: "training-class-modules", 
      label: "Modules", 
      children: 
        <ClassModules classeId={recordId} /> 
    },

    { 
      key: "training-class-participants", 
      label: "Participants", 
      children: 
        <ClassParticipants classeId={recordId} /> 
    },

    { 
      key: "training-module-results", 
      label: "Results", 
      children: 
        <TrainingModuleResults classeId={recordId} /> 
    },
  ];

  const onChange = (key) => {
    setActiveTab(key);
    navigate(`/console/training-classes/${recordId}/${key}`);
  };

  return <Tabs type="card" activeKey={activeTab} onChange={onChange} items={items} />;
};


export default TrainingClassTab;
